import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link, useParams, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import "./Blog_Details.css";

import { useContext } from "react";
import { Context } from "../../../../utils/context";
const BlogDetailsModal = (props) => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();
  const { getData, imageUrl } = useContext(Context);
  // const { id } = useParams();
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);

  // const imageSource = queryParams.get("imageSource");

  // const [blogPost, setBlogPost] = useState(null);

  return (
    <>
      <Modal {...props} size="xl" centered scrollable dialogClassName="blog-details-modal">
        <Modal.Header closeButton>
          <Modal.Title>Blog Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <section className="BlogDetails">
            <div className="container-fluid">
              <div className="row mb-4">
                <div className="col-12">
                  <Link
                    onClick={props.onHide}
                    className="blog-back-link text-decoration-none"
                  >
                    <span className="goToBlog_txt">← Back to Blogs</span>
                  </Link>
                </div>
              </div>

              <div className="row blog_details align-items-center">
                <div className="col-lg-7 col-md-12">
                  <div className="BlogonBanner_content">
                    <h1 className="Blogdetails_heading">
                      {props?.data?.title}
                    </h1>

                    <div className="Blogdetails_date">
                      <FontAwesomeIcon icon={faCalendarDays} className="me-2" />
                      {props?.data?.date}
                    </div>
                  </div>
                </div>

                <div className="col-lg-5 col-md-12">
                  <div className="blogdetails_imgsection">
                    <img
                      src={imageUrl + props?.data?.image}
                      className="blogDetails_Backimg"
                      alt={props?.data?.title}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-10 mx-auto">
                  <div className="blogDetails_below_info">
                    <div className="blogDetails_content_section">
                      {htmlToReactParser.parse(props?.data?.description || "")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BlogDetailsModal;
